import axios from 'axios';
import { API_BASE_URL } from '../config/constants';
import { isTokenExpired } from '../utils/tokenUtils';

let refreshInFlight = null;

const refreshAxios = axios.create({
  baseURL: API_BASE_URL ? `${API_BASE_URL}/auth` : '/api/auth',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  },
  withCredentials: true
});

const broadcastTokenUpdate = (token, refreshToken) => {
  if (typeof window !== 'undefined' && typeof window.broadcastTokenUpdate === 'function') {
    window.broadcastTokenUpdate(token, refreshToken);
  }
};

const persistTokens = (accessToken, refreshToken) => {
  localStorage.setItem('token', accessToken);
  if (refreshToken) {
    localStorage.setItem('refresh_token', refreshToken);
  }
  broadcastTokenUpdate(accessToken, refreshToken);
};

const requestRefresh = async () => {
  const refreshToken = localStorage.getItem('refresh_token');
  if (!refreshToken || isTokenExpired(refreshToken)) {
    throw new Error('Refresh token expired or missing');
  }

  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 10000);

  try {
    const response = await refreshAxios.post(
      '/refresh',
      { refresh_token: refreshToken },
      { signal: controller.signal }
    );

    const accessToken = response?.data?.access_token || response?.data?.token;
    const nextRefreshToken = response?.data?.refresh_token;
    if (!accessToken) {
      throw new Error('Invalid token response');
    }

    persistTokens(accessToken, nextRefreshToken);
    return accessToken;
  } finally {
    clearTimeout(timeoutId);
  }
};

export const refreshAccessTokenSingleFlight = () => {
  if (!refreshInFlight) {
    refreshInFlight = requestRefresh().finally(() => {
      refreshInFlight = null;
    });
  }

  return refreshInFlight;
};

